/* eslint-disable no-unused-vars */
import { Grouping } from './grouping/Grouping';
import * as S from './LeftSideHeader.styled';

export const LeftSideHeader = ({ originalTableData$, filteredData$, isNoData$, sortConfig$ }) => {
  return (
    <>
      <Grouping
        originalTableData$={originalTableData$}
        filteredData$={filteredData$}
        sortConfig$={sortConfig$}
      />
      {!isNoData$.value ? <S.Total>Total:</S.Total> : null}
    </>
  );
};
